import type { ActivityPayload, AttendanceVerification } from '../api/types';

export function scopedVerification(
  payload: ActivityPayload | undefined,
  ownerEmail: string | null,
): AttendanceVerification {
  const evidence = payload?.attendance_verification ?? { removed: [], unverified: [] };
  if (!ownerEmail) return evidence;
  return {
    removed: evidence.removed.filter(member => member.sdr_owner_email === ownerEmail),
    unverified: evidence.unverified.filter(member => member.sdr_owner_email === ownerEmail),
  };
}

// Only the removals are worth a word. Unverified sittings count like any other meeting, so the
// label never mentions them.
export function verificationLabel(evidence: AttendanceVerification): string {
  return `${evidence.removed.length} no-show${evidence.removed.length === 1 ? '' : 's'} removed`;
}

// "Gong" for a single call; "Gong 1", "Gong 2" when a meeting has several recordings.
export function gongLinkLabel(position: number, callCount: number): string {
  return callCount > 1 ? `Gong ${position + 1}` : 'Gong';
}
